import * as T from '@/core/configs/types'
import { Note, NoteForm } from './note'
export const ContainerUpcoming = 'Upcoming'
export const ContainerArrived = 'Arrived'
export const ContainerEmpty = 'Empty'
export const ContainerReturned = 'Returned'

export const ContainerStatus = {
  ContainerUpcoming,
  ContainerArrived,
  ContainerEmpty,
  ContainerReturned
}

export const PickUpInfo = {
  billingReferenceNo: {
    type: T.String,
    label: 'Billing Reference No.',
    key: 'billingReferenceNo'
  },
  riiOpEmail: {
    type: T.String,
    label: 'RII Op Email',
    key: 'riiOpEmail'
  },
  truckCompanyName: {
    type: T.String,
    label: 'Trucking Company',
    key: 'truckCompanyName'
  },
  truckCompanyFax: {
    type: T.String,
    label: 'Trucking Co. Fax',
    key: 'truckCompanyFax'
  },
  truckCompanyTel: {
    type: T.String,
    label: 'Trucking Co. Tel',
    key: 'truckCompanyTel'
  },
  truckCompanyEmail: {
    type: T.String,
    label: 'Trucking Co. Email',
    key: 'truckCompanyEmail'
  },
  truckCompanyAddress: {
    type: T.String,
    label: 'Trucking Co. Address',
    key: 'truckCompanyAddress'
  },
  pickUpAddress: {
    type: T.String,
    label: 'Pick Up Address',
    key: 'pickUpAddress'
  },
  deliveryAddress: {
    type: T.String,
    label: 'Delivery Address',
    key: 'deliveryAddress'
  },
  containerSize: {
    type: T.String,
    label: 'Container Size',
    key: 'containerSize'
  },
  containerWeight: {
    type: T.Number,
    label: 'Container Weight',
    key: 'containerWeight'
  },
  counts: {
    type: T.Number,
    label: 'Counts',
    key: 'counts'
  }
}

export const Container = {
  id: {
    type: T.String,
    label: 'Order ID',
    key: 'id'
  },
  status: {
    type: T.Enum,
    label: 'Container Status',
    key: 'status',
    options: Object.values(ContainerStatus)
  },
  no: {
    type: T.String,
    label: 'RII Container No.',
    key: 'no',
    col: 'rii_container_no'
  },
  containerNo: {
    type: T.String,
    label: 'Container No.',
    key: 'containerNo',
    col: 'container_no'
  },
  mbl: {
    type: T.String,
    label: 'MBL',
    key: 'mbl'
  },
  terminalPort: {
    type: T.String,
    label: 'Terminal Port',
    key: 'terminalPort'
  },
  eta: {
    type: T.Time,
    label: 'ETA',
    key: 'eta',
    col: 'eta'
  },
  estimatedDeliveryDate: {
    type: T.Time,
    label: 'Estimated Delivery Date',
    key: 'estimatedDeliveryDate',
    col: 'estimated_delivery_date'
  },
  deliveryDate: {
    label: 'Delivery Date',
    key: 'deliveryDate',
    type: T.Time,
    col: 'delivery_date'
  },
  emptyDate: {
    label: 'Empty Date',
    key: 'emptyDate',
    type: T.Time,
    col: 'empty_date'
  },
  returnDate: {
    label: 'Return Date',
    key: 'returnDate',
    type: T.Time,
    col: 'return_date'
  },
  pickUpInfo: {
    type: T.Ref,
    ref: PickUpInfo,
    label: 'Pick Up Info',
    key: 'pickUpInfo',
    col: 'pick_up_info'
  },
  notes: {
    type: T.Array,
    itemType: T.Ref,
    ref: Note,
    label: 'Note',
    key: 'notes'
  },
  createdTime: {
    type: T.Time,
    label: 'Created on',
    key: 'createdTime'
  },
  updatedTime: {
    type: T.Time,
    label: 'Updated on',
    key: 'updatedTime'
  }
}

export const ContainerForm = Object.fromEntries(
  [
    {
      ...Container.containerNo,
      span: 1,
      type: T.TextInput,
      example: 'MATU2675842',
      default: 'MATU2675842',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...Container.mbl,
      span: 1,
      type: T.TextInput,
      example: 'MATU2675842',
      default: 'MATU2675842',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...Container.terminalPort,
      span: 1,
      type: T.TextInput,
      example: 'FMS',
      default: 'FMS',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...Container.eta,
      span: 1,
      type: T.TimeSelect,
      example: '2022-04-12T23:20:50.52Z',
      default: '2022-04-12T23:20:50.52Z',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...Container.estimatedDeliveryDate,
      span: 1,
      type: T.TimeSelect,
      example: '2022-04-12T23:20:50.52Z',
      default: '2022-04-12T23:20:50.52Z',
      value: '',
      validators: []
    },
    ...NoteForm
  ].map(one => [one.key, one])
)

const ContainerInfoPicks = [
  {
    ...Container.no,
    type: T.Text,
    span: 1
  },
  { ...ContainerForm.containerNo, type: T.Text, span: 1 },
  { ...ContainerForm.mbl, type: T.Text, span: 1 },
  { ...ContainerForm.terminalPort, type: T.Text, span: 1 },
  { ...Container.status, type: T.Tag, effect: 'dark', span: 1 },
  { ...ContainerForm.eta, type: T.Time, span: 1 },
  { ...ContainerForm.estimatedDeliveryDate, type: T.Time, span: 1 },
  { ...Container.deliveryDate, type: T.Time, span: 1 },
  { ...Container.emptyDate, type: T.Time, span: 1 },
  { ...Container.returnDate, type: T.Time, span: 1 }
]

export const ContainerInfoWrapUp = T.generateWrapUp(ContainerInfoPicks)

export const ContainerInfoModifyForm = Object.fromEntries(
  [
    {
      ...Container.containerNo,
      span: 1,
      type: T.TextInput,
      example: 'MATU2675842',
      default: 'MATU2675842',
      value: 'MATU2675842',
      validators: [T.RequiredValidator]
    },
    {
      ...Container.status,
      span: 1,
      type: T.Select,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...Container.mbl,
      span: 1,
      type: T.TextInput,
      example: 'MATU2675842',
      default: 'MATU2675842',
      value: 'MATU2675842',
      validators: [T.RequiredValidator]
    },
    {
      ...Container.terminalPort,
      span: 1,
      type: T.TextInput,
      example: 'FMS',
      default: 'FMS',
      value: 'FMS',
      validators: [T.RequiredValidator]
    },
    {
      ...Container.eta,
      span: 1,
      type: T.TimeSelect,
      example: '',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...Container.estimatedDeliveryDate,
      span: 1,
      type: T.TimeSelect,
      example: '',
      default: '',
      value: '',
      validators: []
    },
    {
      ...Container.deliveryDate,
      span: 1,
      type: T.TimeSelect,
      example: '',
      default: '',
      value: '',
      validators: []
    },
    {
      ...Container.emptyDate,
      span: 1,
      type: T.TimeSelect,
      example: '',
      default: '',
      value: '',
      validators: []
    },
    {
      ...Container.returnDate,
      span: 1,
      type: T.TimeSelect,
      example: '',
      default: '',
      value: '',
      validators: []
    }
  ].map(one => [one.key, one])
)

export const PickUpInfoForm = Object.fromEntries(
  [
    {
      ...PickUpInfo.truckCompanyName,
      type: T.TextArea,
      span: 2,
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...PickUpInfo.truckCompanyTel,
      type: T.TextInput,
      span: 1,
      default: '',
      validators: []
    },
    {
      ...PickUpInfo.truckCompanyAddress,
      type: T.TextArea,
      span: 2,
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...PickUpInfo.truckCompanyEmail,
      type: T.TextInput,
      span: 1,
      default: '',
      validators: []
    },
    {
      ...PickUpInfo.containerSize,
      type: T.TextInput,
      span: 1,
      default: '',
      validators: []
    },
    {
      ...PickUpInfo.counts,
      type: T.NumberInput,
      span: 1,
      default: '',
      validators: []
    },
    {
      ...PickUpInfo.truckCompanyFax,
      type: T.TextInput,
      span: 1,
      default: '',
      validators: []
    },
    {
      ...PickUpInfo.pickUpAddress,
      type: T.TextArea,
      span: -1,
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    }
  ].map(one => [one.key, one])
)

const PickUpInfoPicks = [
  { ...PickUpInfoForm.containerSize, type: T.Text },
  { ...PickUpInfoForm.counts, type: T.Text },
  { ...PickUpInfoForm.truckCompanyName, type: T.Text },
  { ...PickUpInfoForm.truckCompanyFax, type: T.Text },
  { ...PickUpInfoForm.truckCompanyTel, type: T.Text },
  { ...PickUpInfoForm.truckCompanyEmail, type: T.Text },
  { ...PickUpInfoForm.truckCompanyAddress, type: T.Text },
  { ...PickUpInfoForm.pickUpAddress, type: T.Text, effect: 'dark' }
]

export const PickUpInfoWrapUp = T.generateWrapUp(PickUpInfoPicks)

export const ContainerModifyCheck = containerInfo => {
  // const hintMsg = ''
  let passed = true
  const hintMsgs = []
  let errMsg = ''
  /**
   * 输入检查
   * 1. 设置 status 时候需要相应的日期
   */
  if (
    containerInfo.eta == null ||
    containerInfo.estimatedDeliveryDate == null
  ) {
    return {
      passed: false,
      errMsg: 'ETA或者Estimated Delivery Date 时间为空！'
    }
  }
  if (containerInfo.status === ContainerReturned) {
    if (containerInfo.deliveryDate == null || containerInfo.emptyDate == null) {
      errMsg =
        '设置container状态为' +
        ContainerReturned +
        '，需要设置DeliveryDate和EmptyDate'
      return { passed: false, errMsg }
    }
    if (containerInfo.returnDate == null) {
      hintMsgs.push('Return Date将被设置为今天的日期')
    }
  } else if (containerInfo.status === ContainerEmpty) {
    if (containerInfo.deliveryDate == null) {
      passed = false
      errMsg =
        '设置container状态为' +
        ContainerEmpty +
        '需要同时设置DeliveryDate和EmptyDate'
      return { passed: false, errMsg }
    }
    if (containerInfo.returnDate != null) {
      hintMsgs.push('return date 将会被清除')
    }
    if (containerInfo.emptyDate == null) {
      hintMsgs.push('Empty Date将被设置为今天的日期')
    }
  } else if (containerInfo.status === ContainerArrived) {
    if (containerInfo.emptyDate != null) {
      hintMsgs.push('Empty date 将会被清除')
    }
    if (containerInfo.returnDate != null) {
      hintMsgs.push('Return date 将会被清除')
    }
    if (containerInfo.deliveryDate == null) {
      hintMsgs.push('Delivery Date将被设置为今天的日期')
    }
  } else if (containerInfo.status === ContainerUpcoming) {
    if (containerInfo.emptyDate != null) {
      hintMsgs.push('Empty date 将会被清除')
    }
    if (containerInfo.returnDate != null) {
      hintMsgs.push('Return date 将会被清除')
    }
    if (containerInfo.deliveryDate != null) {
      hintMsgs.push('Delivery date 将会被清除')
    }
  }
  if (hintMsgs.length === 0) {
    hintMsgs.push('以下操作将修改container 信息，是否继续？')
  }
  return { passed, hintMsgs, errMsg }
}

export const APMContainer = [
  {
    label: 'Container ID',
    key: 'ContainerId',
    type: T.String
  },
  {
    label: 'Bill Of Lading',
    key: 'BillOfLading',
    type: T.Array
  },
  {
    label: 'Ready for delivery?',
    key: 'ReadyForDelivery',
    type: T.Boolean
  },
  {
    label: 'Status',
    key: 'ContainerState',
    type: T.String
  },
  {
    label: 'Line',
    key: 'LineId',
    type: T.String
  },
  {
    label: 'Vessel name',
    key: 'VesselName',
    type: T.String
  },
  {
    label: 'Vessel ETA',
    key: 'VesselEta',
    type: T.String
  },
  {
    label: 'Discharge Date',
    key: 'DischargedDate',
    type: T.String
  },
  {
    label: 'Yard Location',
    key: 'YardLocation',
    type: T.String
  },
  {
    label: 'Freight',
    key: 'Freight',
    type: T.String
  },
  {
    label: 'Customs',
    key: 'Customs',
    type: T.String
  },
  {
    label: 'Holds',
    Holds: 'Holds',
    type: T.Array
  },
  {
    label: 'Good Thru',
    key: 'GoodThru',
    type: T.String
  },
  {
    label: 'Demurrage',
    key: 'Demurrage',
    type: T.String
  },
  {
    label: 'Size / Type / Height',
    key: 'SizeTypeHeight',
    type: T.String
  },
  {
    label: 'Weight',
    key: 'GrossWeight',
    type: T.String
  },
  {
    label: 'Hazardous',
    key: 'HazardousClass',
    type: T.String
  },
  {
    label: 'Appointment date*',
    key: 'AppointmentDate',
    type: T.String
  },
  {
    label: 'Gate Out Date',
    key: 'GateOutDate',
    type: T.String
  }
]

export const LBCTContainer = [
  {
    label: 'CONTAINER',
    key: 'containerId',
    type: T.String
  },
  {
    label: 'AVAILABLE',
    key: 'available',
    type: T.String
  },
  {
    label: 'TYPE',
    key: 'type',
    type: T.String
  },
  {
    label: 'LINE',
    key: 'line',
    type: T.String
  },
  {
    label: 'VESSEL',
    key: 'vessel',
    type: T.String
  },
  {
    label: 'Discharged',
    key: 'discharged',
    type: T.String
  },
  {
    label: 'Location',
    key: 'location',
    type: T.String
  },
  {
    label: 'Delivered',
    key: 'dateDeliverd',
    type: T.String
  },
  {
    label: 'Full/Empty',
    key: 'freightKind',
    type: T.String
  },
  {
    label: 'Exam Status',
    key: 'examStatus',
    type: T.String
  },
  {
    label: 'Bond Status',
    key: 'bondStatus',
    type: T.String
  }
]

export const PCTContainer = [
  {
    label: 'Container',
    key: 'container'
  },
  {
    label: 'Available for pickup?',
    key: 'available'
  },
  {
    label: 'Size/Type',
    key: 'sizeType'
  },
  {
    label: 'Customs Release Status',
    key: 'customsReleaseStatus'
  },
  {
    label: 'Line Release Status',
    key: 'lineReleaseStatus'
  },
  {
    label: 'Holds',
    key: 'holds'
  },
  {
    label: "Add'l Holds Info",
    key: 'holdsInfo'
  },
  {
    label: 'Total Fees',
    key: 'totalFees'
  },
  {
    label: 'Satisfied Thru',
    key: 'satisfiedThru'
  },
  {
    label: 'Location',
    key: 'location'
  },
  {
    label: 'Ves/Voy',
    key: 'vesVoy'
  },
  {
    label: 'Line',
    key: 'line'
  },
  {
    label: 'Delivery Order',
    key: 'deliveryOrder'
  },
  {
    label: 'Required Accessory',
    key: 'requiredAccessory'
  }
]

const MASTContainer = []

export const FENIXContainer = [
  {
    label: 'Container Number',
    key: 'containerNumber'
  },
  {
    label: 'Category',
    key: 'category'
  },
  {
    label: 'Line Op',
    key: 'lineOp'
  },
  {
    label: 'Type',
    key: 'type'
  },
  {
    label: 'Position',
    key: 'position'
  }
]

export const PIERAContainer = [
  {
    label: 'Container',
    key: 'container'
  },
  {
    label: 'Available for pickup?',
    key: 'available'
  },
  {
    label: 'Size/Type',
    key: 'sizeType'
  },
  {
    label: 'Customs Release Status',
    key: 'customsReleaseStatus'
  },
  {
    label: 'Line Release Status',
    key: 'lineReleaseStatus'
  },
  {
    label: 'Holds',
    key: 'holds'
  },
  {
    label: "Add'l Holds Info",
    key: 'holdsInfo'
  },
  {
    label: 'Total Fees',
    key: 'totalFees'
  },
  {
    label: 'Satisfied Thru',
    key: 'satisfiedThru'
  },
  {
    label: 'Location',
    key: 'location'
  },
  {
    label: 'Ves/Voy',
    key: 'vesVoy'
  },
  {
    label: 'Line',
    key: 'line'
  },
  {
    label: 'Delivery Order',
    key: 'deliveryOrder'
  },
  {
    label: 'Required Accessory',
    key: 'requiredAccessory'
  }
]

export const ContainerDocks = {
  APM: APMContainer,
  LBCT: LBCTContainer,
  PCT: PCTContainer,
  MAST: MASTContainer,
  FENIX: FENIXContainer,
  PIERA: PIERAContainer
}
